module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-common-wrapper"
  }, _vm._l((_vm.menuList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nav-common-item",
      on: {
        "click": function($event) {
          return _vm.toPage(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "70px",
        "height": "70px"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "18px",
        "color": "#3f3f3f 100%"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65dfe519"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/navCommon.vue
// module id = 1620
// module chunks = 1